/**
 * Le code de confidentialité, côté application : sa longueur et ce qui le rend
 * trop facile à deviner. Le serveur applique les mêmes règles ; les répéter ici
 * évite un aller-retour pour s'entendre dire « 1234 est trop simple ».
 */
export const PIN_LENGTH = 4;

/**
 * Un seul chiffre répété, ou une suite montante ou descendante : ce sont les
 * codes que l'on essaie en premier sur un téléphone trouvé.
 */
export function isTrivialPin(pin: string): boolean {
  const digits = [...pin].map(Number);
  const steps = digits.slice(1).map((digit, index) => digit - digits[index]);
  return (
    steps.every((step) => step === 0) ||
    steps.every((step) => step === 1) ||
    steps.every((step) => step === -1)
  );
}
